import { createContext } from 'react';
import type { IAccessSnapshot } from './resolve';

// A fixed access snapshot for the parts of the console that run without a real
// `GET /v1/me` — the offline dev provider (`VITE_AUTH0_DISABLE`), Storybook and tests.
//
//   - `preferStore: true` (dev provider): `/v1/me` is still read, and a REAL access-store
//     assignment (`source: 'store'`, e.g. `?dev_user=`) wins over the snapshot; anything
//     else (the BFF's bypass operator, a BFF that is down) falls back to the snapshot.
//   - `preferStore: false` (stories, tests): the snapshot is the answer; nothing is fetched.

export interface IAccessOverride {
  access: IAccessSnapshot;
  preferStore: boolean;
}

export const AccessOverrideContext = createContext<IAccessOverride | null>(null);
